export default __webpack_public_path__ + "static/grafana-fab418b750efc980674aad8c5ce81e62.png";